import React from 'react';
import { useSelector } from "react-redux";
import { mainSelector } from "../../store/slices/main.slice";
import HamburgerMenu from "./HamburgerMenu";

interface VTRoomHeaderProps {
    services: any;
}

const VTRoomHeader: React.FC<VTRoomHeaderProps> = ({ services }) => {
    const { sound } = useSelector(mainSelector);

    return (
        <header className="flex flex-row items-center justify-between w-full gap-[50px] px-[20px] sm:px-[40px] h-[84px] sm:h-[60px] lg:h-[84px]">
            <div>
                <img onClick={services.goToHome} src="/images/GNDM acronimo orizzontale white.png" alt="Header GNDM Logo" className="max-h-[20px] cursor-pointer lg:hidden"/>
                <img onClick={services.goToHome} src="/images/GNDM logo full.png" alt="Header GNDM Logo" className="max-h-[30px] cursor-pointer hidden lg:block"/>
            </div>
            <div className="flex flex-row items-center h-max gap-[35px] lg:gap-[50px]">
                <button onClick={services.openInfo} className="mr-[-10px] w-[20px] h-[25px] min-w-[10px] min-h-[25px] flex flex-col items-center justify-center cursor-pointer"><img src="/images/info-icon.png" alt="Info icon" className="h-full"/></button>
                <button onClick={services.handleSound} className="w-[25px] h-[25px] min-w-[25px] min-h-[25px] flex flex-col items-center justify-center cursor-pointer"><img src={sound ? "/images/sound-icon.png" : "/images/sound_off.png"} alt="Sound icon" className="h-full"/></button>
                <div className="relative ml-[20px] sm:ml-[10px]"><HamburgerMenu version="white" onClick={services.openMenu}/></div>
            </div>
        </header>
    );
};

export default VTRoomHeader;
